// import React, { useEffect } from "react";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import {
//     faCheck,
//     faTimes,
//     faMinus,
//     faCutlery,
//     faXmark,
// } from "@fortawesome/free-solid-svg-icons";
// import ConvertTime from "../convertTime";
// import Calculation from "../Calculation";

// const DenseCardModal = ({
//     element,
//     onClose,
//     handleFinished,
//     handleCompleted,
//     handleMinus,
//     handleCancel,
//     handleCookProcess,
// }) => {
//     // Close on Escape key
//     useEffect(() => {
//         const onKey = (e) => {
//             if (e.key === "Escape") onClose();
//         };
//         document.addEventListener("keydown", onKey);
//         return () => document.removeEventListener("keydown", onKey);
//     }, [onClose]);

//     // Prevent body scroll while modal open
//     useEffect(() => {
//         document.body.style.overflow = "hidden";
//         return () => {
//             document.body.style.overflow = "";
//         };
//     }, []);

//     const isStarted = element.currentState === "Started";

//     return (
//         /* Backdrop */
//         <div
//             className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
//             onClick={onClose}
//         >
//             {/* Modal panel — stop propagation so clicks inside don't close */}
//             <div
//                 className="
//                     relative w-full max-w-sm
//                     bg-white rounded-xl shadow-2xl
//                     overflow-hidden
//                     animate-[modalIn_0.18s_ease-out]
//                 "
//                 onClick={(e) => e.stopPropagation()}
//                 style={{ animation: "modalIn 0.18s ease-out" }}
//             >
//                 <style>{`
//                     @keyframes modalIn {
//                         from { opacity: 0; transform: scale(0.94) translateY(8px); }
//                         to   { opacity: 1; transform: scale(1)    translateY(0); }
//                     }
//                 `}</style>

//                 {/* ── Header ── */}
//                 <div
//                     className={`
//                         grid grid-cols-[1fr_auto_1fr] items-center
//                         bg-gradient-to-r
//                         ${isStarted
//                             ? "from-red-900 via-red-600 to-rose-500"
//                             : "from-violet-800 via-violet-700 to-purple-600"
//                         }
//                         text-white px-3 py-3
//                     `}
//                 >
//                     {/* KOT */}
//                     <div>
//                         <div className="text-xs uppercase tracking-wider">KOT ID</div>
//                         <div className="text-sm font-semibold">{element.KOTID}</div>
//                     </div>

//                     {/* Order type */}
//                     <div className="text-center text-sm font-semibold uppercase tracking-wider">
//                         {element.orderType}
//                     </div>

//                     {/* Complete button + close */}
//                     <div className="flex justify-end">
//                         <button
//                             onClick={onClose}
//                             className="
//                                 w-7 h-7 rounded-full
//                                 bg-white/15 border border-white/20
//                                 text-white
//                                 hover:bg-white hover:!text-black
//                                 active:scale-95
//                                 transition-all duration-150
//                                 flex items-center justify-center
//                             "
//                             title="Close"
//                         >
//                             <FontAwesomeIcon icon={faXmark} className="text-xs" />
//                         </button>
//                     </div>
//                 </div>

//                 {/* ── Order meta ── */}
//                 <div className="bg-amber-50 border-b border-amber-100 px-3 py-2.5 text-center">
//                     <div className="flex justify-between text-xs text-amber-800 font-medium mb-1 tracking-wide">
//                         <ConvertTime timeOrder={element.orderTime} />
//                         <span>Guests: {element.Guest_count}</span>
//                     </div>

//                     <div className="text-base font-semibold uppercase tracking-wider text-amber-900">
//                         {element.tableNum === "Take-Away"
//                             ? "Take-Away"
//                             : `Table ${element.tableNum}`}
//                     </div>

//                     <div className="text-sm font-medium text-amber-700 mt-0.5 tracking-wide">
//                         {element.employee}
//                     </div>

//                     <div className="mt-1 text-xs">
//                         <Calculation Ordertime={element.orderTime} />
//                     </div>
//                 </div>

//                 {/* ── Items list ── */}
//                 <div className="divide-y divide-gray-100 max-h-80 tiny-scrollbar overflow-y-auto">
//                     {element.OrderItemDetailsList.map((item, idx) => (
//                         <div
//                             key={idx}
//                             className="grid grid-cols-[36px_1fr_72px] items-center px-3 py-2.5 text-sm font-medium text-gray-800"
//                         >
//                             {/* Qty badge */}
//                             <div className="w-7 h-7 rounded-full bg-gray-100 text-gray-700 flex items-center justify-center font-bold text-xs">
//                                 {item.Quantity}
//                             </div>

//                             {/* Item Name + Modifications */}
//                             <div className="break-words leading-snug px-1.5">
//                                 <div>{item.ItemName}</div>
//                                 {item.Modifications && item.Modifications.trim() !== "" && (
//                                     <div className="text-[10px] xl:text-xs font-normal italic text-violet-600 mt-0.5 break-words tracking-wide">
//                                         {item.Modifications}
//                                     </div>
//                                 )}
//                             </div>

//                             {/* Action buttons */}
//                             <div className="flex gap-1.5 justify-end">
//                                 <button
//                                     onClick={() => handleFinished(item.item_id)}
//                                     className="w-7 h-7 rounded-md bg-green-100 text-green-700 hover:bg-green-600 hover:text-white active:scale-90 active:bg-green-700 transition-all duration-150 flex items-center justify-center"
//                                     aria-label="Mark item done"
//                                 >
//                                     <FontAwesomeIcon icon={faCheck} className="text-xs" />
//                                 </button>

//                                 {item.Quantity > 1 ? (
//                                     <button
//                                         onClick={() => handleMinus(item.item_id)}
//                                         className="w-7 h-7 rounded-md bg-amber-100 text-amber-700 hover:bg-amber-500 hover:text-white active:scale-90 active:bg-amber-700 transition-all duration-150 flex items-center justify-center"
//                                         aria-label="Decrease quantity"
//                                     >
//                                         <FontAwesomeIcon icon={faMinus} className="text-xs" />
//                                     </button>
//                                 ) : (
//                                     <button
//                                         onClick={() => handleCancel(item.item_id)}
//                                         className="w-7 h-7 rounded-md bg-red-100 text-red-600 hover:bg-red-600 hover:text-white active:scale-90 active:bg-red-700 transition-all duration-150 flex items-center justify-center"
//                                         aria-label="Cancel item"
//                                     >
//                                         <FontAwesomeIcon icon={faTimes} className="text-xs" />
//                                     </button>
//                                 )}
//                             </div>
//                         </div>
//                     ))}
//                 </div>

//                 {/* ── Footer action ── */}
//                 <div className="p-3 bg-gray-50 border-t border-gray-100">
//                     {isStarted ? (
//                         <button
//                             onClick={() => {
//                                 handleCookProcess(element.table_id);
//                                 onClose();
//                             }}
//                             className="
//                                 w-full rounded-md
//                                 bg-violet-600
//                                 py-2.5 text-xs text-white uppercase
//                                 font-semibold tracking-widest
//                                 hover:bg-violet-700
//                                 active:scale-95 active:bg-violet-800
//                                 transition-all duration-150
//                             "
//                         >
//                             Mark as seen
//                         </button>
//                     ) : (
//                         <button
//                             onClick={() => {
//                                 handleCompleted(element.table_id);
//                                 onClose();
//                             }}
//                             className="w-full rounded-md bg-emerald-500 py-2.5 text-sm text-white hover:bg-emerald-600 active:scale-95 active:bg-emerald-700 transition-all duration-150 flex items-center justify-center gap-2"
//                         >
//                             <FontAwesomeIcon icon={faCutlery} />
//                             <span className="text-xs font-semibold tracking-widest uppercase">
//                                 Complete Order
//                             </span>
//                         </button>
//                     )}
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default DenseCardModal;

















import React, { useEffect, useState, useRef, useCallback } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faCheck,
    faCutlery,
    faXmark,
} from "@fortawesome/free-solid-svg-icons";
import ConvertTime from "../convertTime";
import Calculation from "../Calculation";
import { FiMinus, FiPlus } from "react-icons/fi";

// ─── Inline Qty Picker ────────────────────────────────────────────────────────
const InlineQtyPicker = ({ item, onConfirm, onCancel }) => {
    const max = item.Quantity;
    const [qty, setQty] = useState(1);
    const [error, setError] = useState("");

    const validate = (val) => {
        const n = parseInt(val, 10);
        if (isNaN(n) || n < 1) { setError("Enter at least 1"); return false; }
        if (n > max) { setError(`Max is ${max}`); return false; }
        setError("");
        return true;
    };

    const handleChange = (val) => { setQty(val); validate(val); };

    const adjust = (delta) => {
        const next = Math.max(1, Math.min(max, (parseInt(qty, 10) || 0) + delta));
        handleChange(next);
    };

    return (
        <div className="bg-violet-50 border-t border-violet-100 px-3 py-2.5 animate-[slideDown_0.15s_ease-out]">
            <style>{`
                @keyframes slideDown {
                    from { opacity: 0; transform: translateY(-6px); }
                    to   { opacity: 1; transform: translateY(0); }
                }
            `}</style>

            <div className="text-[10px] text-violet-600 font-medium mb-1.5 tracking-wide uppercase">
                Qty to mark done — max {max}
            </div>

            <div className="flex items-center gap-2">
                {/* Stepper */}
                <div className="flex items-center gap-1.5 flex-1">
                    <button
                        onClick={() => adjust(-1)}
                        className="p-1.5 rounded-md border border-gray-200 bg-gray-50 hover:bg-gray-100 active:scale-95 transition-all"
                    >
                        <FiMinus size={14} />
                    </button>

                    <input
                        type="number"
                        value={qty}
                        min={1}
                        max={max}
                        onChange={(e) => handleChange(e.target.value)}
                        className={`w-20 text-center text-sm font-semibold rounded-md border py-1 outline-none transition-colors
                            ${error
                                ? "border-red-400 bg-red-50 text-red-700"
                                : "border-gray-200 bg-white text-gray-900 focus:border-violet-400"
                            }`}
                    />

                    <button
                        onClick={() => adjust(1)}
                        className="p-1.5 rounded-md border border-gray-200 bg-gray-50 hover:bg-gray-100 active:scale-95 transition-all"
                    >
                        <FiPlus size={14} />
                    </button>
                </div>

                {/* Actions */}
                <button
                    onClick={onCancel}
                    className="w-7 h-7 rounded-md bg-gray-100 text-gray-500 hover:bg-gray-200 active:scale-95 flex items-center justify-center transition-all"
                    aria-label="Cancel"
                >
                    <FontAwesomeIcon icon={faXmark} className="text-xs" />
                </button>

                <button
                    onClick={() => { if (validate(qty)) onConfirm(parseInt(qty, 10)); }}
                    disabled={!!error || qty === ""}
                    className="h-7 px-3 rounded-md bg-emerald-500 hover:bg-emerald-600 disabled:opacity-40 disabled:cursor-not-allowed text-white text-xs font-semibold flex items-center gap-1 active:scale-95 transition-all"
                >
                    <FontAwesomeIcon icon={faCheck} className="text-xs" />
                    Done
                </button>
            </div>

            {error && (
                <p className="text-xs font-semibold italic tracking-wide text-red-500 mt-1">{error}</p>
            )}
        </div>
    );
};

// ─── DenseCardModal ───────────────────────────────────────────────────────────
const DenseCardModal = ({
    element,
    onClose,
    handleFinished,   // now: (itemId, quantity) => void
    handleCompleted,
    handleMinus,
    handleCancel,
    handleCookProcess,
}) => {
    const [expandedItemId, setExpandedItemId] = useState(null);

    useEffect(() => {
        const onKey = (e) => { if (e.key === "Escape") onClose(); };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [onClose]);

    useEffect(() => {
        document.body.style.overflow = "hidden";
        return () => { document.body.style.overflow = ""; };
    }, []);

    const isStarted = element.currentState === "Started";

    // Long-press logic
    const pressTimer = useRef(null);
    const didLongPress = useRef(false);
    const LONG_PRESS_MS = 500;

    const startPress = useCallback((item) => {
        didLongPress.current = false;
        pressTimer.current = setTimeout(() => {
            didLongPress.current = true;
            navigator.vibrate?.(60);
            handleFinished(item.item_id, item.Quantity);
            setExpandedItemId(null);
        }, LONG_PRESS_MS);
    }, [handleFinished]);

    const cancelPress = useCallback(() => {
        clearTimeout(pressTimer.current);
    }, []);

    const handleCheckClick = useCallback((item) => {
        if (didLongPress.current) return;
        setExpandedItemId((prev) => prev === item.item_id ? null : item.item_id);
    }, []);

    const handleConfirm = (item, qty) => {
        handleFinished(item.item_id, qty);
        setExpandedItemId(null);
    };

    return (
        <div
            className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
            onClick={onClose}
        >
            <div
                className="relative w-full max-w-sm bg-white rounded-xl shadow-2xl overflow-hidden"
                onClick={(e) => e.stopPropagation()}
                style={{ animation: "modalIn 0.18s ease-out" }}
            >
                <style>{`
                    @keyframes modalIn {
                        from { opacity: 0; transform: scale(0.94) translateY(8px); }
                        to   { opacity: 1; transform: scale(1)    translateY(0); }
                    }
                `}</style>

                {/* ── Header ── */}
                <div
                    className={`grid grid-cols-[1fr_auto_1fr] items-center bg-gradient-to-r
                        ${isStarted
                            ? "from-red-900 via-red-600 to-rose-500"
                            : "from-violet-800 via-violet-700 to-purple-600"
                        } text-white px-3 py-3`}
                >
                    <div>
                        <div className="text-xs uppercase tracking-wider">KOT ID</div>
                        <div className="text-sm font-semibold">{element.KOTID}</div>
                    </div>
                    <div className="text-center text-sm font-semibold uppercase tracking-wider">
                        {element.orderType}
                    </div>
                    <div className="flex justify-end">
                        <button
                            onClick={onClose}
                            className="w-7 h-7 rounded-full bg-white/15 border border-white/20 text-white hover:bg-white hover:!text-black active:scale-95 transition-all duration-150 flex items-center justify-center"
                            title="Close"
                        >
                            <FontAwesomeIcon icon={faXmark} className="text-xs" />
                        </button>
                    </div>
                </div>

                {/* ── Order meta ── */}
                <div className="bg-amber-50 border-b border-amber-100 px-3 py-2.5 text-center">
                    <div className="flex justify-between text-xs text-amber-800 font-medium mb-1 tracking-wide">
                        <ConvertTime timeOrder={element.orderTime} />
                        <span>Guests: {element.Guest_count}</span>
                    </div>
                    <div className="text-base font-semibold uppercase tracking-wider text-amber-900">
                        {element.tableNum === "Take-Away" ? "Take-Away" : `Table ${element.tableNum}`}
                    </div>
                    <div className="text-sm font-medium text-amber-700 mt-0.5 tracking-wide">
                        {element.employee}
                    </div>
                    <div className="mt-1 text-xs">
                        <Calculation Ordertime={element.orderTime} />
                    </div>
                </div>

                {/* ── Items list ── */}
                <div className="divide-y divide-gray-100 max-h-80 tiny-scrollbar overflow-y-auto">
                    {element.OrderItemDetailsList.map((item, idx) => (
                        <div key={idx}>
                            {/* Item row */}
                            <div className={`grid grid-cols-[36px_1fr_72px] items-center px-3 py-2.5 text-sm font-medium text-gray-800 transition-colors
                                ${expandedItemId === item.item_id ? "bg-violet-50/60" : ""}`}
                            >
                                {/* Qty badge */}
                                <div className="w-7 h-7 rounded-full bg-gray-100 text-gray-700 flex items-center justify-center font-bold text-xs">
                                    {item.Quantity}
                                </div>

                                {/* Item Name + Modifications */}
                                <div className="break-words leading-snug px-1.5">
                                    <div>{item.ItemName}</div>
                                    {item.Modifications && item.Modifications.trim() !== "" && (
                                        <div className="text-[10px] xl:text-xs font-normal italic text-violet-600 mt-0.5 break-words tracking-wide">
                                            {item.Modifications}
                                        </div>
                                    )}
                                </div>

                                {/* Action buttons */}
                                <div className="flex justify-end">
                                    {/* Check — click opens picker, long press marks all */}
                                    <button
                                        onPointerDown={() => startPress(item)}
                                        onPointerUp={cancelPress}
                                        onPointerLeave={cancelPress}
                                        onClick={() => handleCheckClick(item)}
                                        className={`w-7 h-7 rounded-md transition-all duration-150 flex items-center justify-center select-none
                                            ${expandedItemId === item.item_id
                                                ? "bg-green-600 text-white"
                                                : "bg-green-100 text-green-700 hover:bg-green-600 hover:text-white"
                                            } active:scale-90`}
                                        aria-label="Mark item done"
                                    >
                                        <FontAwesomeIcon icon={faCheck} className="text-xs" />
                                    </button>
                                </div>
                            </div>

                            {/* Inline qty picker — expands below the row */}
                            {expandedItemId === item.item_id && (
                                <InlineQtyPicker
                                    item={item}
                                    onConfirm={(qty) => handleConfirm(item, qty)}
                                    onCancel={() => setExpandedItemId(null)}
                                />
                            )}
                        </div>
                    ))}
                </div>

                {/* ── Footer ── */}
                <div className="p-3 bg-gray-50 border-t border-gray-100">
                    {isStarted ? (
                        <button
                            onClick={() => { handleCookProcess(element.table_id); onClose(); }}
                            className="w-full rounded-md bg-violet-600 py-2.5 text-xs text-white uppercase font-semibold tracking-widest hover:bg-violet-700 active:scale-95 active:bg-violet-800 transition-all duration-150"
                        >
                            Mark as seen
                        </button>
                    ) : (
                        <button
                            onClick={() => { handleCompleted(element.table_id); onClose(); }}
                            className="w-full rounded-md bg-emerald-500 py-2.5 text-sm text-white hover:bg-emerald-600 active:scale-95 active:bg-emerald-700 transition-all duration-150 flex items-center justify-center gap-2"
                        >
                            <FontAwesomeIcon icon={faCutlery} />
                            <span className="text-xs font-semibold tracking-widest uppercase">
                                Complete Order
                            </span>
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DenseCardModal;